// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Pu8L","header":"PatientBlock_header__15YZ2","label":"PatientBlock_label__26JMX","option":"PatientBlock_option__M_aYF"};